import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfDigitalIntensityScoreService } from '../../../core/application/services/scores/get-self-digital-intensity-score.service';
import { SelfDigitalIntensityScoreAggregateRoot } from '../../../core/domain/aggregates/scores/self-digital-intensity-score.aggregate-root';
import { GetSelfAllScoresRequestDto } from '../../dtos/scores/self-get-all-scores.request.dto';

export class GetSelfDigitalIntensityScoreQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetSelfDigitalIntensityScoreService
  ) {}
  async execute(
    props: GetSelfAllScoresRequestDto
  ): Promise<SelfDigitalIntensityScoreAggregateRoot> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
